<div class="admin-reset-ds-connection-container">
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <span>Select the service to reset the connection for : </span>
      <select class="form-control" [value]="selectedApi" (change)="selectedApi = $any($event.target).value; onServiceChange()">
        @for (opt of apis; track $index) {
          <option [value]="opt.value">{{ opt.name }}</option>
        }
      </select>
    </div>
    <div class="form-group">
      <span>Refresh the datasource details from Database?</span>
      <input type="checkbox" [checked]="refreshFromDb" (change)="refreshFromDb = $any($event.target).checked" />
    </div>
    <div class="form-group">
      <span>Include Core Datasource (globalTaxDS)?</span>
      <input type="checkbox" [checked]="includeCoreDS" (change)="includeCoreDS = $any($event.target).checked" />
    </div>
    @if (tags.length > 0) {
      <div class="form-group">
        Reset datasource connection for below datasources :
      </div>
    }
    @if (tags.length > 0) {
      <div class="tags-list">
        @for (tag of tags; track $index; let i = $index) {
          <div class="tag-item">
            <span class="fa fa-tag"></span>
            <span class="tag-label">{{ tag }}</span>
            <button type="button" class="btn-remove" (click)="removeTag(i)"><i class="fa fa-times"></i></button>
          </div>
        }
      </div>
    }
    @if (tags.length === 0) {
      <div class="no-id-block">
        No datasource is selected.
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="save-button" [disabled]="saveloader" (click)="reTriggerMessage()">
      @if (saveloader) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
        } Reset Connection
      </button>
      <button type="button" class="purge-button" [disabled]="saveloader" (click)="purgeConnections()">
        @if (saveloader) {
          <span><i class="fa fa-spinner fa-pulse"></i></span>
          } Purge Connections
        </button>
        <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
      </div>
    </div>
